import Phaser from 'phaser';
import { createAllTextures } from '../textures/index.js';
import WebFont from 'webfontloader';
import { UIManager } from '../managers/UIManager.js';
import { CONSTANTS } from '../game.js';

export class BootScene extends Phaser.Scene {
    constructor() {
        super({ key: 'BootScene' });
    }

    preload() {
        console.log('BootScene: Preload function called');
        
        const width = this.cameras.main.width;
        const height = this.cameras.main.height;

        // ロード画面の表示
        const progressBar = this.add.graphics();
        const progressBox = this.add.graphics();
        
        // プログレスボックスのサイズと位置を計算
        const boxWidth = width * 0.7; // 画面幅の70%
        const boxHeight = 50;
        const boxX = (width - boxWidth) / 2;
        const boxY = height / 2 + 20; // ローディングテキストの下に配置

        progressBox.fillStyle(0x222222, 0.8);
        progressBox.fillRect(boxX, boxY, boxWidth, boxHeight);
        const loadingText = this.make.text({
            x: width / 2,
            y: height / 2 - 50,
            text: 'Loading...',
            style: {
                font: '20px DotGothic16',
                fill: '#ffffff'
            }
        });
        loadingText.setOrigin(0.5, 0.5);
        
        // プログレスバーの表示
        const barPadding = 10; // ボックスの内側のパディング
        this.load.on('progress', function (value) {
            progressBar.clear();
            progressBar.fillStyle(0xffffff, 1);
            progressBar.fillRect(
                boxX + barPadding,
                boxY + barPadding,
                (boxWidth - barPadding * 2) * value,
                boxHeight - barPadding * 2
            );
        });
        
        this.load.on('complete', function () {
            progressBar.destroy();
            progressBox.destroy();
            loadingText.destroy();
        });
        
        // フォントロードの完了を待つためのプロミスを作成
        this.fontsReady = false;
        this.fontsPromise = new Promise(resolve => {
            WebFont.load({
                google: {
                    families: ['Noto Serif JP:400,700', 'DotGothic16']
                },
                active: () => {
                    console.log('BootScene: フォントロード完了');
                    this.fontsReady = true;
                    resolve();
                },
                inactive: () => {
                    console.error('BootScene: フォントロードに失敗しました');
                    this.fontsReady = true; // エラーでも進める
                    resolve();
                }
            });
        });
        
        // サウンドのロード
        this.load.audio('bgm', 'assets/sounds/maou_bgm_neorock72.mp3');
        this.load.audio('breakSound', 'assets/sounds/maou_se_system18.wav');
        
        // ターゲット破壊時の効果音をロード（評価ごとに異なる効果音を設定可能）
        this.load.audio('target_hit_perfect', 'assets/sounds/springin_bakuhatsu_1.mp3');
        this.load.audio('target_hit_great', 'assets/sounds/springin_hakai_karui.mp3');
        this.load.audio('target_hit_good', 'assets/sounds/springin_hakai_karui.mp3');
        this.load.audio('target_hit_pass', 'assets/sounds/springin_hakai_karui.mp3');
        this.load.audio('target_hit_fail', 'assets/sounds/springin_hakai_karui.mp3');
    }

    async create() {
        console.log('BootScene: Create function called');
        
        this.input.setDefaultCursor('pointer');
        
        // UIマネージャーの初期化
        this.uiManager = new UIManager(this);
        
        // リビジョン情報の表示
        this.uiManager.createRevisionText();
        
        // まずフォントロードの完了を待つ
        if (!this.fontsReady) {
            console.log('BootScene: フォントロードの完了を待っています...');
            await this.fontsPromise;
        }
        
        // document.fonts.readyを使用して、ブラウザがフォントを完全に処理するまで待機
        if (document.fonts && document.fonts.ready) {
            console.log('BootScene: ブラウザのフォント処理完了を待っています...');
            try {
                await document.fonts.ready;
                console.log('BootScene: ブラウザのフォント処理が完了しました');
            } catch (error) {
                console.error('BootScene: ブラウザのフォント処理待機中にエラーが発生しました', error);
                // エラーが発生しても処理を続行
            }
        } else {
            // document.fonts.readyがサポートされていない場合は、短いディレイを追加
            console.log('BootScene: document.fonts.readyがサポートされていないため、短いディレイを追加します');
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        // フォントロード完了後にテクスチャを生成
        console.log('BootScene: フォントロード完了後、テクスチャ生成を開始します');
        this.texturesReady = false;
        try {
            const success = await createAllTextures(this);
            if (success) {
                console.log('BootScene: テクスチャ生成完了');
            } else {
                console.error('BootScene: テクスチャ生成に一部失敗しました');
            }
            this.texturesReady = true;
        } catch (error) {
            console.error('BootScene: テクスチャ生成中にエラーが発生しました', error);
            this.texturesReady = true; // エラーでも進める
        }
        
        // タイトルシーンに遷移
        this.scene.start('TitleScene');
    }
}
